import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Auth from '../../Helpers/auth';
import PrimaryButtonComponent from '../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import PropTypes from 'prop-types';
import {
  CourseInfoTable,
  SidebySide,
  CartItemsList,
  CheckoutSummaryPanel,
  CheckoutError,
  SecureNote,
  PaymentContainer,
  RecommendedCoursesArea,
} from './Course.styles';
import EachCartItem from './Components/CartItem/EachCartItem.component';
import TotalDivComponent from '../../Ip/IPCheckout/IPCart/TotalDiv.component';
import { httpCreateOrder } from '../../Hooks/orders/order.hooks';
import PageHeader from '../../Components/PageHeader/PageHeader.component';
// import RecommendedPopularCourses from './Components/RecommendedCourses.component';
import RecommendedCourses from '../DisplayCourseInfo/RecommendedCourse/RecommendedCourses.component';
// User Checkout
const CheckoutInnerPage = ({ courses }) => {
  const data = Auth.getProfile();
  const userId = data?.data?.id || localStorage.getItem('temp_id');
  const isAuthenticated = Boolean(Auth.getToken());
  const navigate = useNavigate();
  // console.log('CheckoutInnerPage - userId:', userId);
  const [checkoutError, setCheckoutError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 900 : false
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 900);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // NS 14% tax only
  const taxRate = 0.14;
  const [taxAmount, setTaxAmount] = useState(0);
  const [subtotal, setSubtotal] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    // Calculate subtotal
    const newSubtotal = Array.isArray(courses)
      ? courses.reduce((acc, course) => acc + (course.price || 0), 0)
      : 0;
    setSubtotal(newSubtotal);

    // Always use NS 14%
    const rate = taxRate;

    // Calculate tax and total
    const newTax = parseFloat((newSubtotal * rate).toFixed(2));
    setTaxAmount(newTax);
    setTotalAmount(parseFloat((newSubtotal + newTax).toFixed(2)));
  }, [courses]);

  async function handleStripeCheckout() {
    try {
      setIsLoading(true);
      setCheckoutError('');

      const courseIds = courses.map((course) => course.courseId);
      if (!userId || courseIds.length === 0) {
        setCheckoutError('User not authenticated or no courses selected.');
        setIsLoading(false);
        return;
      }

      const response = await httpCreateOrder({
        userId,
        courseIds,
      });

      const data = await response.json();

      if (!response.ok) {
        setCheckoutError(data.error || 'Unable to start checkout.');
        setIsLoading(false);
        return;
      }

      if (data.url) {
        window.location.href = data.url;
      }
    } catch (err) {
      setCheckoutError(err.message);
      setIsLoading(false);
    }
  }

  // If returning from login/signup flow and flag is set, auto-trigger checkout
  React.useEffect(() => {
    const doPostLoginCheckout = async () => {
      try {
        const flag = localStorage.getItem('post_login_checkout');
        if (flag && isAuthenticated && courses?.length) {
          localStorage.removeItem('post_login_checkout');
          await handleStripeCheckout();
        }
      } catch (err) {
        console.error('Auto checkout failed:', err);
      }
    };
    doPostLoginCheckout();
  }, [isAuthenticated]);

  return (
    <>
      <SidebySide>
        <CourseInfoTable>
          <PageHeader
            eyebrow="Order Review"
            title="Your Cart"
            desc="Review your selected courses before continuing to secure checkout. Course access is available instantly after payment."
            showPartTwo={true}
          />

          <CartItemsList>
            {Array?.isArray(courses) &&
              courses?.map((course) => (
                <EachCartItem
                  course={course}
                  id={course?.courseId}
                  key={course._id}
                  userId={userId}
                />
              ))}
          </CartItemsList>
        </CourseInfoTable>

        <CheckoutSummaryPanel>
          <TotalDivComponent
            subtotal={subtotal.toFixed(2)}
            taxAmount={taxAmount}
            totalAmount={totalAmount}
          />

          <PaymentContainer>
            {checkoutError && <CheckoutError>{checkoutError}</CheckoutError>}

            {isAuthenticated ? (
              <PrimaryButtonComponent
                className="checkoutButton"
                // style={{ minWidth: '100%' }}
                functionName={handleStripeCheckout}
                disabled={isLoading || !courses?.length}
                span={
                  isLoading ? 'Redirecting...' : 'Continue to Secure Checkout'
                }
              />
            ) : (
              <PrimaryButtonComponent
                className="checkoutButton"
                // style={{ minWidth: '100%' }}
                functionName={() => navigate('/checkout/auth')}
                disabled={!courses?.length}
                span="Sign in or create account"
              />
            )}

            <SecureNote>Payments securely processed by Stripe</SecureNote>
          </PaymentContainer>
        </CheckoutSummaryPanel>

        {!isMobile && (
          <RecommendedCoursesArea>
            <RecommendedCourses course={courses[0]} />
          </RecommendedCoursesArea>
        )}
      </SidebySide>
    </>
  );
};
CheckoutInnerPage.propTypes = {
  courses: PropTypes.array,
};

export default CheckoutInnerPage;
